<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import ButtonAll from '../UI/Button/ButtonAll.vue'
import BooleanIcon from '../UI/Icon/BooleanIcon.vue'

const props = withDefaults(
  defineProps<{
    billingCodes?: BillingCode[]
  }>(),
  {
    billingCodes: () => [],
  },
)

const emit = defineEmits<{
  edit: [{ billingCode: BillingCode }]
}>()

const { t } = useI18n()

function editBillingCode(billingCode: BillingCode) {
  emit('edit', { billingCode })
}
</script>

<template>
  <table class="table table-responsive table-striped mb-0">
    <thead>
      <tr>
        <th class="font-weight-bold col-3">
          {{ t('entity.information.billingCodeList.registrationNumber') }}
        </th>
        <th class="font-weight-bold col-3">
          {{ t('entity.information.billingCodeList.address') }}
        </th>
        <th class="font-weight-bold col-2">
          {{ t('entity.information.billingCodeList.code') }}
        </th>
        <th class="font-weight-bold col-2">
          {{ t('entity.information.billingCodeList.active') }}
        </th>
        <th class="font-weight-bold col-2">
          {{ t('entity.information.billingCodeList.defaultBillingCode') }}
        </th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="billingCode in billingCodes" :key="billingCode.id">
        <td>
          {{ billingCode.address?.siret ?? '-' }}
        </td>
        <td>
          <span v-if="billingCode.address?.formattedHtml" v-html="billingCode.address.formattedHtml" />
          <span v-else>-</span>
        </td>
        <td>
          {{ billingCode.code }}
        </td>
        <td>
          <BooleanIcon :value="billingCode.active" />
        </td>
        <td>
          <BooleanIcon :value="billingCode.default" />
        </td>
        <td>
          <ButtonAll type="add" icon="modify" size="small" margin="no" @click="editBillingCode(billingCode)" />
        </td>
      </tr>
      <tr v-if="!billingCodes?.length">
        <td colspan="6" class="text-center">
          {{ t('entity.information.billingCodeList.empty') }}
        </td>
      </tr>
    </tbody>
  </table>
</template>
